document.addEventListener('DOMContentLoaded', () => {
  const openModalButton = document.querySelectorAll('.js-pwdOpenModal');
  const modalWrapper = document.querySelector('#pwd-modal');
  const modalOverlay = document.querySelector('#pwd-modal__overlay');
  const closeButton = document.querySelector('#pwd-modal .close');

  openModalButton.forEach((button) => {
    button.addEventListener('click', () => openModal());
  });
  modalOverlay.addEventListener('click', () => closeModal());
  closeButton.addEventListener('click', () => closeModal());

  function openModal() {
    modalWrapper.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modalWrapper.classList.remove('show');
    document.body.style.overflow = 'auto';
  }
});